<template>
    <div>
        <table border="1">
            <caption>
                个人信息权限
            </caption>
            <tr>
                <td>权限分组</td>
                <td>权限名</td>
                <td>功能描述</td>
                <td>可访问的个人信息</td>
                <td>使用场景</td>
            </tr>

            <tr>
                <td>CAMERA相机</td>
                <td>CAMERA拍摄</td>
                <td>允许App使用摄像头</td>
                <td>照片或视频信息</td>
                <td>例如拍摄照片</td>
            </tr>

            <tr>
                <td>LOCATION位置</td>
                <td>ACCESS_FINE_LOCATION访问精准定位</td>
                <td>允许App获取基于GPS 的精准地理位置</td>
                <td>精准地理位置信息</td>
                <td>用于查询附近门店位置及导航</td>
            </tr>

            <tr>
                <td>LOCATION位置</td>
                <td>ACCESS_COARSE_LOCATION访问粗略位置</td>
                <td>允许App获取基于基站、IP 粗略的地理位置</td>
                <td>粗略地理位置信息</td>
                <td>用于查询附近门店位置及导航</td>
            </tr>
            <tr>
                <td>LOCATION位置</td>
                <td>ACCESS_BACKGROUND_LOCATION支持后台访问位置</td>
                <td>
                    允许App在后台运行时使用位置信息（需要App获得访问粗略位置或访问精准位置权限）
                </td>
                <td>实时地理位置信息、行踪轨迹</td>
                <td>用于查询附近门店位置及导航</td>
            </tr>

            <tr>
                <td>PHONE电话</td>
                <td>READ_PHONE_STATE读取电话状态</td>
                <td>
                    App可通过此权限获取设备IMSI（国际移动用户识别码）、IMEI（国际移动设备识别码） 设备唯一标识信息，以及手机通话状态 
                </td>
                <td>设备唯一标识信息（如IMEI、设备序列号）</td>
                <td>进行用户常用设备的标识，可用于监测App账户异常登录、关联用户行为</td>
            </tr>

            <tr>
                <td>PHONE电话</td>
                <td>READ_PHONE_NUMBERS读取本机电话号码</td>
                <td>允许App读取用户的本机电话号码</td>
                <td>手机号码</td>
                <td>移动、电信、联通本机号码一键登录</td>
            </tr>

            <tr>
                <td>BODY_SENSORS身体传感器</td>
                <td>BODY_SENSORS获取身体传感器信息</td>
                <td>允许App访问身体内部状况相关的传感器数据，一般特指心率传感器数据</td>
                <td>心率 身体传感器数据</td>
                <td>例如运动健身、健康类App及可穿戴设备显示心率 状况</td>
            </tr>

            <tr>
                <td>STORAGE存储</td>
                <td>READ_EXTERNAL_STORAGE读取外置存储器</td>
                <td>允许App读取外置存储器</td>
                <td>外置存储器存储的个人数据</td>
                <td>例如文件管理、阅读器 打开本地文件的场景 </td>
            </tr>
            <tr>
                <td>STORAGE存储</td>
                <td>WRITE_EXTERNAL_STORAGE写入外置存储器</td>
                <td>允许App写入外置存储器</td>
                <td>外置存储器存储的个人数据</td>
                <td>例如存储拍摄的照片和视频，及下载文件、需要下载的资源 </td>
            </tr>
            <tr>
                <td>ACTIVITY_RECOGNITION身体活动</td>
                <td>ACTIVITY_RECOGNITION识别身体活动</td>
                <td>允许App识别身体活动</td>
                <td>特定身体活动变化信息（如未移动、步行、跑步、骑车、坐车 ）</td>
                <td>
                    例如追踪用户步数及卡路里消耗、需要对用户的身体活动进行分类的场景 
                </td>
            </tr>

            <tr>
                <td></td>
                <td>CHANGE_WIFI_STATE改变WLAN状态的开关</td>
                <td>允许App打开或关闭Wi-Fi</td>
                <td>网络配置信息</td>
                <td></td>
            </tr>
        </table>
    </div>
</template>

<script>
export default {
    name: "PersonalInformationList",
    data(){
        return{

        }
    },
    created() {
        document.title = "个人信息收集表";
    },
};
</script>

<style scoped>
    /* .body{
        width: 100%;
    } */
    *{
        font-size: 12px;
        font-weight: 600;
    }

</style>


// WEBPACK FOOTER //
// src/components/PersonalInformationList.vue